import { render } from "./qilist.vue?vue&type=template&id=70cc32ea&scoped=true"
import script from "./qilist.vue?vue&type=script&lang=js"
export * from "./qilist.vue?vue&type=script&lang=js"

import "./qilist.vue?vue&type=style&index=0&id=70cc32ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cc32ea"]])

export default __exports__